/**
 * AngleRole - Role para conversão de unidades de ângulo
 *
 * Implementa os 4 pilares: Convert, Cast, Validate, Format
 *
 * @example
 * const angle = new AngleRole();
 * angle.convert('degree', 'radian', 180)   // π ≈ 3.14159
 * angle.cast('degree', '90°')              // 90
 * angle.validate('degree', 90)             // { valid: true, errors: [] }
 * angle.format('degree', 45)               // "45°"
 */

import { SimpleRole } from "../../contracts";
import { ANGLE_UNITS, ANGLE_ALIASES } from "./constants";

// =============================================================================
// ANGLE ROLE CLASS
// =============================================================================

export class AngleRole extends SimpleRole {
  readonly name = "angle";
  readonly base = "degree";
  readonly units = ANGLE_UNITS;
  readonly aliases = ANGLE_ALIASES;

  // Ângulo pode ser negativo (rotação anti-horária) e maior que 360° (múltiplas voltas)
  // Não definimos min/max na validação
}

// =============================================================================
// SINGLETON INSTANCE
// =============================================================================

/** Instância singleton da AngleRole */
export const angleRole = new AngleRole();
